import { isSafariBrowser } from "./detect-safari";

export default {


    init: function () {
        if (!window.AnimationEvent) { return; }
        
        // Check use of back button
        this.reloadPageAfterHistoryTraversal()

        const anchors = this.findAnchors()
        const animationElement = document.querySelector(".page-transition-visual");

        // Start animation when anchors are clicked & defer location change untill the animation ended
        this.deferLocationChangeAfterAnimationEnded(anchors, animationElement)

        // Start out animation immediatly after the page has loaded
        this.animateWhenPageLoaded(animationElement);
    },

    animateBeforeLocationChange: function (animationElement) {
        animationElement.classList.add('page-transition-visual--visible');
        const layer = animationElement.querySelector('.page-transition-visual__layer-wrapper--start-anim')

        layer.style.display = '';
        layer.classList.add('page-transition-visual__layer-wrapper--running')
    },

    animateAfterLocationChange: function (animationElement) {
        const layer = animationElement.querySelector('.page-transition-visual__layer-wrapper--end-anim')

        layer.addEventListener('animationend', () => {
            animationElement.classList.remove('page-transition-visual--visible')
        })

        layer.classList.add('page-transition-visual__layer-wrapper--running')
    },

    deferLocationChangeAfterAnimationEnded: function (anchors, animationElement) {

        anchors.forEach(anchor => anchor.addEventListener('click', event => {

            const listener = function () {

                animationElement.removeEventListener('animationend', listener);
                window.location = anchor.href;
            };

            animationElement.addEventListener('animationend', listener)

            event.preventDefault()


            this.animateBeforeLocationChange(animationElement)
        }));
    },

    animateWhenPageLoaded: function (animationElement) {

        window.addEventListener('pageshow', event => {

            if (event.persisted) {
                // When the page is loaded from local cache, we need to
                // clean up in order to display the page immediatly

                if(isSafariBrowser()) {
                    return window.location.reload() 
                }

                return animationElement.classList.remove('page-transition-visual--visible')
            }

            // alert('kom ik hier')
            this.animateAfterLocationChange(animationElement)
        })
    },

    findAnchors: function () {
        const anchors = Array.from(document.getElementsByTagName('a'));

        // Filter outbounding links & links to the same page
        return anchors.filter(anchor => {
            return this.linksToTheSameAddress(anchor) &&
                this.doesNotLinkToCurrentPage(anchor) &&
                this.doesNotOpenInNewTabOrWindow(anchor)
        })
    },


    linksToTheSameAddress(anchor) {
        return anchor.hostname === window.location.hostname;
    },

    doesNotLinkToCurrentPage(anchor) {
        return anchor.pathname !== window.location.pathname;
    },

    doesNotOpenInNewTabOrWindow(anchor) {
        return ['_self', ''].includes(anchor.target);
    },

    reloadPageAfterHistoryTraversal: function() {
        window.addEventListener( "pageshow", function ( event ) {
            var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
            if ( historyTraversal ) {
              // Handle page restore.
              document.body.style.display = 'none';
              window.location.reload();
            }
        });
    }

}
